import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import DspAudienceTargetsMgmt from './components/DspAudienceTargetsMgmt';

export default function DspContextualTargetsPage() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Amazon DSP Audience Targets</h3>
        </Col>
      </Row>
      <Row>
        <DspAudienceTargetsMgmt />
      </Row>
    </Container>
  );
}
